import { render, staticRenderFns } from "./ContentPageFormScreen.vue?vue&type=template&id=79ec6145&"
import script from "./ContentPageFormScreen.vue?vue&type=script&lang=ts&"
export * from "./ContentPageFormScreen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports